import { components as RSComponents } from 'react-select';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import Select from '../../elements/Select';

// react-select Option that shows a styled hover tooltip when the option carries a `tooltip` field.
const TooltipOption = (props) => {
    const { data } = props;
    if (!data || !data.tooltip) return <RSComponents.Option {...props} />;
    return (
        <OverlayTrigger placement="right" overlay={<Tooltip id={`select-opt-${data.value}`}>{data.tooltip}</Tooltip>}>
            <div><RSComponents.Option {...props} /></div>
        </OverlayTrigger>
    );
};

// Reusable single-select with per-option tooltips. Pass options as [{ value, label, tooltip }];
// options without a `tooltip` render normally. All other Select / react-select props are forwarded.
const SelectWithTooltip = ({ components, ...rest }) => (
    <Select {...rest} components={{ Option: TooltipOption, ...(components || {}) }} />
);

export default SelectWithTooltip;
